export var EAuthErrorType = /*#__PURE__*/function (EAuthErrorType) {
  /** блок на 1 час **/
  EAuthErrorType["CodeInputLimitReached"] = "codeInputLimitReached";
  /** блок на 15 мин **/
  EAuthErrorType["TemporaryBlock"] = "TemporaryBlock";
  /** постоянный блок **/
  EAuthErrorType["PermanentBlock"] = "PermanentBlock";
  return EAuthErrorType;
}({});